import './App.css';
import { lazy, Suspense } from 'react';
import { FeedbackProvider } from './feedback/FeedbackProvider';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import AdminLogin from './Pages/AdminLogin/AdminLogin';
import AdminLayout from './Layout/AdminLayout';
import CategoryManagement from './Pages/CategoryManagement/CategoryManagement';
import PrescriptionsReports from './Pages/PrescriptionsReports/PrescriptionsReports';
import BidResponsesOverview from './Pages/BidResponsesOverview/BidResponsesOverview';
import PatientMedicalSubmissions from './Pages/PatientMedicalSubmissions/PatientMedicalSubmissions';
import ReviewApproval from './Pages/ReviewApproval/ReviewApproval';
import NewSignUps from './Pages/NewSignUps/NewSignUps';
import ProviderDirectoryDetail from './Pages/NewSignUps/ProviderDirectoryDetail';
import PatientDetail from './Pages/PatientDetail/PatientDetail';
import Settings from './Pages/Settings/Settings';
import LocationSearch from './Pages/LocationSearch/LocationSearch';
import Gallery from './Pages/Gallery/Gallery';
import SupportLive from './Pages/SupportLive/SupportLive';
const Dashboard = lazy(() => import('./Pages/Dashboard/Dashboard'));
const Bids = lazy(() => import('./Pages/Bids/Bids'));
const Notifications = lazy(() => import('./Pages/Notifications/Notifications'));

function App() {
  return (
    <div className="App">
      <FeedbackProvider theme="admin">
      <Router>
        <Suspense fallback={<div style={{ padding: 16 }}>Loading...</div>}>
        <Routes>
          <Route path='/' element={<AdminLogin />} />
          <Route path='/AdminLayout' element={<AdminLayout />} />
          <Route path='/Dashboard' element={< Dashboard />} />
          <Route path='/location-search' element={<LocationSearch />} />
          <Route path='/quick-access' element={<Navigate to="/Dashboard" replace />} />
          <Route path='/new-signups' element={<NewSignUps />} />
          <Route path='/patient-list/:patientId' element={<PatientDetail />} />
          <Route path='/patient-list' element={<NewSignUps />} />
          <Route path='/provider-list' element={<NewSignUps />} />
          <Route path='/doctor-list/:providerId' element={<ProviderDirectoryDetail />} />
          <Route path='/doctor-list' element={<NewSignUps />} />
          <Route path='/hospital-list/:providerId' element={<ProviderDirectoryDetail />} />
          <Route path='/hospital-list' element={<NewSignUps />} />
          <Route path='/Bid' element={<Bids />} />
          <Route path='/active-bids' element={<Navigate to="/Bid" replace />} />
          <Route path='/notifications' element={<Notifications />} />
          <Route path='/review-approval' element={<ReviewApproval />} />
          <Route path='/category-management' element={<CategoryManagement />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path="/prescriptions-reports" element={<PrescriptionsReports />} />
          <Route path="/BidResponsesOverview" element={<BidResponsesOverview />} />
          <Route path="/patient-medical-submissions" element={<PatientMedicalSubmissions />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/patient-support" element={<SupportLive />} />
          <Route path="/support-live" element={<Navigate to="/patient-support" replace />} />
          <Route path="/compliance" element={<Navigate to="/Dashboard" replace />} />

        </Routes>
        </Suspense>
      </Router>
      </FeedbackProvider>
    </div>
  );
}

export default App;
